import { useQuery, UseQueryResult } from 'react-query';
import { TimesheetAPI } from 'api/timesheets';
import { RejectNoteType } from 'components/organisms/timesheets/types';

export const getRejectNoteQueryKey = (startDate: string) =>
  `timesheet-reject-note-${startDate}`;

export const useTimesheetGetRejectNote = (
  userId: number,
  startDate: string,
): UseQueryResult<RejectNoteType[], unknown> => {
  return useQuery(
    getRejectNoteQueryKey(startDate),
    () => TimesheetAPI.getRejectNote(userId, startDate),
    {
      refetchOnMount: true,
    },
  );
};
